if (Modernizr.mq("(max-width: 64em)")) {
  setTimeout(function () {
    window.location.href = window.location.href + "#content";
  }, 10);
}
